import { CheckOutlined } from '@ant-design/icons';
import classes from './PasswordTootip.module.scss';

const passwordRequirementsList = [
  '8-100 characters',
  'Upper & lowercase letters',
  'At least one number or special character',
];

export const PasswordTooltip = () => {
  return (
    <div>
      Your password must include the following:
      {passwordRequirementsList.map((requirement) => (
        <div>
          <CheckOutlined className={classes.passwordRequirementIcon} />
          {requirement}
        </div>
      ))}
    </div>
  );
};
